import * as React from 'react';
import { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Form,
  Grid,
  GridContainer,
  GridItem,
} from '@enterprise-ui/canvas-ui-react';

export const HeightFormField = ({
  label,
  onChange,
  defaultValue,
  isChangeValid,
}) => {
  const {
    control,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      feet: defaultValue?.toString()?.split('.')[0] || '',
      inches: defaultValue?.toString()?.split('.')[1] || '',
    },
  });

  const feet = watch('feet');
  const inches = watch('inches');
  const [updated, setUpdated] = useState(false); //Stops constant re-rendering
  useEffect(() => {
    if (feet !== '' && inches && updated) {
      const totalHeight = Number(feet) + Number(inches) / 12;
      onChange(totalHeight.toFixed(2)); //Keeps floating points to only two decimals
      setUpdated(false);
    }
    isChangeValid(isValid);
  }, [feet, inches, onChange, updated, setUpdated, isChangeValid, isValid]);

  return (
    <GridContainer>
      <GridItem xs={12} className={'hc-pb-none'}>
        <label className={'hc-fs-xs'}>
          {label}
          <span className={'hc-clr-error hc-fs-lg'}>*</span>
        </label>
      </GridItem>
      <GridItem xs={5} className="hc-pt-min">
        <Controller
          name="feet"
          control={control}
          rules={{
            required: 'Please enter the required feet.',
            min: { value: 1, message: 'Height must be at least 1 foot.' },
            max: { value: 50, message: 'Height must be 50 feet or less.' },
            pattern: {
              value: /^\d+$/,
              message: 'Please enter a whole number.',
            },
          }}
          render={({ field }) => (
            <Form.Field
              data-testid="height_feet"
              type="number"
              step="1"
              id="height_feet"
              error={errors?.feet}
              errorText={errors.feet?.message}
              {...field}
              required
              onWheel={(e) => e.currentTarget.blur()}
              onChange={(e) => {
                field.onChange(e);
                setUpdated(true); // track that the user made a change
              }}
            />
          )}
        />
      </GridItem>
      <Grid.Item xs={1} className="hc-ph-min hc-fs-md hc-clr-grey01">
        <p>ft</p>
      </Grid.Item>
      <Grid.Item xs={5} className={'hc-pt-min'}>
        <Controller
          name="inches"
          control={control}
          rules={{
            required: 'Please enter the required inches.',
            min: { value: 0, message: 'Height must be at least 0 inches.' },
            max: { value: 11, message: 'Height must be 11 inches or less.' },
            pattern: {
              value: /^\d+$/,
              message: 'Please enter a whole number.',
            },
          }}
          render={({ field }) => (
            <Form.Field
              data-testid="reader_height_inches"
              type="number"
              id="reader_height_inches"
              hintText="Enter 0 if none."
              error={errors?.inches}
              errorText={errors.inches?.message}
              {...field}
              step="1"
              required
              onWheel={(e) => e.currentTarget.blur()}
              onChange={(e) => {
                field.onChange(e);
                setUpdated(true); // track that the user made a change
              }}
            />
          )}
        />
      </Grid.Item>
      <Grid.Item xs={1} className="hc-fs-md hc-ph-min hc-clr-grey01">
        <p>in</p>
      </Grid.Item>
    </GridContainer>
  );
};
